export default __webpack_public_path__ + "static/media/intact-example.b9359fbb.png";